import Chart from "../../components/charts/Chart";
import styled from "styled-components";
import FeaturedInfoCard from "../../components/featuredInfoCard/FeaturedInfoCard";
import React, { useContext, useEffect } from "react";
import { DashboardContext } from "../../context/dashboardContext/DashboardContext";
import { getDashboardData } from "../../context/dashboardContext/DashboardApiCalls";

const Container = styled.div`
  flex: 4;
  margin-top: 20px;
`;

const FeatureCardContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Dashboard = () => {
  const { dashboardData, dispatch } = useContext(DashboardContext);	
	
	useEffect(() => {
		getDashboardData(dispatch);
	}, [dispatch], []);

	let lastMonthSales = 0;
	let salesYearTotal = 0;

	if (dashboardData.orderInfos && dashboardData.orderInfos.length > 0) {
		lastMonthSales = dashboardData.orderInfos.at(-1).salesCount;

		salesYearTotal = dashboardData.orderInfos.reduce(function(prev, cur) {
			return prev + cur.salesCount;
		}, 0);
	}

  return (
    <Container>
      <FeatureCardContainer>
        <FeaturedInfoCard title="# of Orders Last Month" value={lastMonthSales} />
        <FeaturedInfoCard title="# of Orders This Year" value={salesYearTotal} />
        <FeaturedInfoCard title="# of Open Claims" value={dashboardData.numberOfOpenCases} />
      </FeatureCardContainer>
      <Chart
        title="Orders"
        data={dashboardData.orderInfos}
        nameKey="monthName"
        valueKey="salesAmount"
        grid={false}
      />
    </Container>
  );
};

export default Dashboard;
